import * as service from './service'
export default {
  namespace: 'equipmentMallOrderDetail',
  state: {
    queryOrderDetailData: {},
    confirmSignData: {}
  },
  effects: {
    * queryOrderDetail ({ payload }, { call, put }) {
      const res = yield call(service.queryOrderDetail, payload)
      yield put({
        type: 'save',
        payload: {
          queryOrderDetailData: res.data.data
        }
      })
      return res.data
    },
    * confirmSign ({ payload }, { call, put }) {
      const res = yield call(service.confirmSign, payload)
      yield put({
        type: 'save',
        payload: {
          confirmSignData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
